import { render, staticRenderFns } from "./CoConfirmation.vue?vue&type=template&id=d630a0c0&"
import script from "./CoConfirmation.vue?vue&type=script&lang=ts&"
export * from "./CoConfirmation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports